import React from 'react'

import styled from 'styled-components'
import { RiPencilFill } from 'react-icons/ri'
import { FaTrashCan } from 'react-icons/fa6'

const CharacterReferenceListItem = ({
  id,
  name,
  email,
  phone,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledListItem>
      <div className="list__item">
        <div className="list__item__header">
          <h5 className="list__item__header_text">{name}</h5>
          <div className="list__item__header__icons">
            <RiPencilFill
              onClick={() =>
                onEdit({
                  id,
                  name,
                  email,
                  phone,
                })
              }
            />
            <FaTrashCan onClick={() => onDelete(id)} />
          </div>
        </div>
        <div className="list__item__body">
          <h5>{email}</h5>
        </div>
        <div className="list__item__body__footer">
          <h5>
            {/* <h5>+{phone}</h5> */}
            <a href={`tel:+${phone}`}>+{phone}</a>
          </h5>
        </div>
      </div>
    </StyledListItem>
  )
}

const StyledListItem = styled.div`
  h5 {
    display: inline;
    font-size: 14px;
    font-weight: 300;
  }

  .list__item {
    border: 1px solid #dfe2ec;
    border-radius: 3px;
    padding-left: 17px;
    margin: 12px 0px 8px 0px;
    cursor: pointer;

    .list__item__header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: baseline;
      padding-top: 11px;

      .list__item__header_text {
        font-weight: 500;
        font-size: 16px;
      }

      .list__item__header__icons {
        display: flex;
        gap: 14px;
        font-size: 18px;
        margin-right: 14px;
        cursor: pointer;
      }
    }

    .list__item__body {
      display: flex;
      justify-content: space-between;
    }

    .list__item__body__footer {
      padding-bottom: 0.5rem;
    }
  }
`

export default CharacterReferenceListItem
